import React, { useEffect } from 'react';

const OAuthCallback = () => {
  useEffect(() => {
    // Check if this page was opened as a popup window
    if (window.opener) {
      // Send a success message back to the main dashboard window
      window.opener.postMessage('GOOGLE_AUTH_SUCCESS', window.location.origin);
      
      // Close this popup automatically
      window.close();
    }
  }, []);

  return (
    // Added some Tailwind classes to match your standard styling
    <div className="flex flex-col justify-center items-center h-screen bg-[#FAF8FF] font-sans cfg-font">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>
      <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200 text-center">
        <h2 className="text-xl font-semibold cfg-heading text-gray-800 mb-2">Authentication Complete</h2>
        <p className="text-gray-600">You can safely close this window.</p>
      </div>
    </div>
  );
};

export default OAuthCallback;